app.service("TranscriptionAPI", [
    "$http",
    "ENV",
    "Session",
    function ($http, ENV, Session) {
        const baseUri = ENV.API + "/api/transcription";

        /**
         * Generates the common headers required for API authentication.
         * @returns {Object} The headers object.
         */
        const getHeaders = function (practiceId) {
            return {
                Authorization: "Bearer " + Session.token,
                "X-PRACTICE-ID": practiceId ? `${practiceId}` : `${Session.practice.id}`,
            };
        };

        var service = {

            // =================================================================
            // Transcription trial
            // =================================================================

            startTrial: function (practiceId) {
                return $http({
                    method: "POST",
                    url: `${baseUri}/trial`,
                    headers: getHeaders(practiceId),
                });
            },

            // =================================================================
            // Transcription Retrieval
            // =================================================================

            getTranscription: function (practiceId, transcriptionId) {
                return $http({
                    method: "GET",
                    url: `${baseUri}/${transcriptionId}`,
                    headers: getHeaders(practiceId),
                });
            },

            getTranscriptionsByPatientId: function (practiceId, patientId) {
                return $http({
                    method: "GET",
                    url: `${baseUri}/patient/${patientId}`,
                    headers: getHeaders(practiceId),
                });
            },

            // =================================================================
            // Transcription Processing
            // =================================================================

            createTranscription: function (practiceId, patientId) {
                return $http({
                    method: "POST",
                    url: `${baseUri}/patient/${patientId}`,
                    headers: getHeaders(practiceId),
                });
            },

            uploadTranscriptionChunk: function (practiceId, transcriptionId, sequenceIndex, formData, isLastChunk) {
                let headers = getHeaders(practiceId);
                headers['Content-Type'] = undefined;

                return $http({
                    method: "PATCH",
                    url: `${baseUri}/${transcriptionId}`,
                    params: { sequenceIndex: sequenceIndex, isLastChunk },
                    data: formData,
                    headers: headers,
                    transformRequest: angular.identity
                });
            },

            reprocessTranscription: function (practiceId, request) {
                return $http({
                    method: "PUT",
                    url: `${baseUri}/reprocess`,
                    data: request,
                    headers: getHeaders(practiceId),
                });
            },

            // =================================================================
            // Prompts
            // =================================================================

            /**
             * Retrieves the list of available transcription prompts.
             * Maps to: GET /api/transcription/prompts
             */
            getTranscriptionPrompts: function (practiceId) {
                return $http({
                    method: "GET",
                    url: `${baseUri}/prompts`,
                    headers: getHeaders(practiceId),
                });
            },

            /**
             * Creates a new transcription prompt.
             * Maps to: POST /api/transcription/prompts
             */
            createTranscriptionPrompt: function (practiceId, promptData) {
                return $http({
                    method: "POST",
                    url: `${baseUri}/prompts`,
                    data: promptData,
                    headers: getHeaders(practiceId)
                });
            },

            /**
             * Updates an existing transcription prompt.
             * Maps to: PUT /api/transcription/prompts/{promptId}
             */
            updateTranscriptionPrompt: function (practiceId, promptId, promptData) {
                return $http({
                    method: "PUT",
                    url: `${baseUri}/prompts/${promptId}`,
                    data: promptData,
                    headers: getHeaders(practiceId)
                });
            },

            /**
             * Deletes a transcription prompt.
             * Maps to: DELETE /api/transcription/prompts/{promptId}
             */
            deleteTranscriptionPrompt: function (practiceId, promptId) {
                return $http({
                    method: "DELETE",
                    url: `${baseUri}/prompts/${promptId}`,
                    headers: getHeaders(practiceId)
                });
            },

            /**
             * Generates or updates a prompt using LLM.
             * Maps to: POST /api/transcription/prompts/generate
             */
            generateTranscriptionPrompt: function (practiceId, generatePrompt, promptText) {
                let data = {
                    'generate_prompt': generatePrompt,
                    'prompt_text': promptText
                };
                return $http({
                    method: "PUT",
                    url: `${baseUri}/prompts/generate`,
                    data: data,
                    headers: getHeaders(practiceId)
                });
            }
        };

        return service;
    },
]);